/**
 * Owner: Masa Bayu
 * File: version-binding.ts
 * Date:Time: 2026-09-15 20:19
 * Description: T1 version / edition binding contracts (refs only, ≠ QXP edit).
 */
import { createQxreadId } from './id';
import { assertNoForbiddenFoundationKey } from './authority';
import { assertOptionalTrimmed, assertTimestamp, assertValidId, VERSION_PATTERN } from './guards';
export const QXREAD_VERSION_BINDING_STATES = ['current', 'pinned', 'superseded', 'broken'];
function assertVersionState(value, label) {
    if (typeof value !== 'string' ||
        !QXREAD_VERSION_BINDING_STATES.includes(value)) {
        throw new Error(`${label} must be one of: ${QXREAD_VERSION_BINDING_STATES.join(', ')}`);
    }
    return value;
}
export function createQxreadVersionBinding(options) {
    assertNoForbiddenFoundationKey(options, 'QXRead version binding');
    assertValidId(options.publicationId, 'QXRead publicationId');
    assertValidId(options.qxpVersionRef, 'QXRead qxpVersionRef');
    const versionLabel = assertOptionalTrimmed(options.versionLabel, 'QXRead versionLabel');
    if (versionLabel === null) {
        throw new Error('QXRead versionLabel is required');
    }
    if (!VERSION_PATTERN.test(versionLabel)) {
        throw new Error('QXRead versionLabel must match semver MAJOR.MINOR.PATCH');
    }
    const bindingId = options.bindingId !== undefined ? options.bindingId : createQxreadId('qxrdver');
    assertValidId(bindingId, 'QXRead bindingId');
    const boundAt = options.boundAt ?? new Date().toISOString();
    assertTimestamp(boundAt, 'QXRead version boundAt');
    let integrityHash = null;
    if (options.integrityHash !== undefined && options.integrityHash !== null) {
        integrityHash = assertOptionalTrimmed(options.integrityHash, 'QXRead integrityHash');
    }
    return Object.freeze({
        bindingId,
        publicationId: options.publicationId,
        qxpVersionRef: options.qxpVersionRef,
        versionLabel,
        state: assertVersionState(options.state ?? 'current', 'QXRead version state'),
        integrityHash,
        boundAt,
    });
}
export function pinVersionBinding(binding) {
    if (binding.state === 'broken') {
        throw new Error('QXRead broken version binding cannot be pinned');
    }
    return createQxreadVersionBinding({
        ...binding,
        state: 'pinned',
    });
}
export function isVersionLaunchable(binding) {
    return binding.state === 'current' || binding.state === 'pinned';
}
//# sourceMappingURL=version-binding.js.map